import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ITournamentTeamModel } from '../../../apis/tournament/model/tournament.model';
import { ComponentStatus, StateComponent } from '../../../components/state/state.component';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TournamentApiService } from '../../../apis/tournament/tournament-api.service';
import { NotificationService } from '../../../services/notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatError, MatFormField, MatHint } from '@angular/material/form-field';
import { LoadingContainerComponent } from '../../../components/loading-container/loading-container.component';

@Component({
  selector: 'oo-create-player-dialog',
  templateUrl: './create-player-dialog.component.html',
  styleUrls: ['./create-player-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingContainerComponent,
    MatDialogTitle,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatHint,
    MatError,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class CreatePlayerDialogComponent extends StateComponent<CreatePlayerDialogComponentState> implements OnInit {

  private readonly fb = inject(UntypedFormBuilder);
  private readonly dialogRef = inject<MatDialogRef<CreatePlayerDialogComponent>>(MatDialogRef);
  private readonly tournamentApi = inject(TournamentApiService);
  private readonly notificationService = inject(NotificationService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly data = inject(MAT_DIALOG_DATA);


  state: CreatePlayerDialogComponentState = {
    status: 'ready',
    form: this.fb.group({
      names: ['', [Validators.required]],
    }),
    team: this.data.team,
  };


  ngOnInit(): void {
    this.dialogRef.updateSize('300px', '400px');
  }

  createPlayers(): void {
    this.updateStatus('loading');
    this.tournamentApi.createTournamentPlayers(this.state.team.tournamentId, this.getPlayersToCreate())
      .then(() => {
        this.snackBar.open('Players were created', undefined, {
          duration: 3000,
        });
        this.dialogRef.close(true);
      })
      .catch((e: Error) => {
        console.error(e);
        this.notificationService.notifyError();
      });
  }

  private getPlayersToCreate(): { players: { name: string; teamId: number }[] } {
    return {
      players: (this.state.form.get('names')!.value as string).split((','))
        .map((name) => name.trim())
        .filter((name) => Boolean(name))
        .map((name) => ({
          teamId: this.state.team.id,
          name: name.trim(),
        })),
    };
  }
}

interface CreatePlayerDialogComponentState {
  status: ComponentStatus;
  form: UntypedFormGroup;
  team: ITournamentTeamModel;
}
